import { render, staticRenderFns } from "./BannerNotification.vue?vue&type=template&id=4ad2f7f3&scoped=true&"
import script from "./BannerNotification.vue?vue&type=script&lang=js&"
export * from "./BannerNotification.vue?vue&type=script&lang=js&"
import style0 from "./BannerNotification.vue?vue&type=style&index=0&id=4ad2f7f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad2f7f3",
  null
  
)

export default component.exports